import { t, useLanguage } from "@/lib/i18n";
import React from "react";
import { Label } from "@/components/ui/label";

export const RELIGIONS = ["Hindu", "Muslim", "Sikh", "Cristian"];

export default function ReligionSelect({ value, onChange, id = "religion", disabled = false }) {
  useLanguage();
  return <div className="space-y-1.5">
    <Label htmlFor={id}>{t("Religion")}</Label>
    <select id={id} data-testid={id} value={value || ""} onChange={(e) => onChange(e.target.value)} disabled={disabled}
      className="h-10 w-full rounded-md border border-input bg-white px-3 text-sm">
      <option value="">{t("Select Religion")}</option>
      {RELIGIONS.map((religion) => <option key={religion} value={religion}>{t(religion)}</option>)}
    </select>
  </div>;
}
